import { useState } from "react";
import { getMonitorLogs, getLogById as getLogByIdApi } from "../../../services/apis/monitorApis";
import { toastError } from "../../../utils/toastUtils";

const useMonitorLogs = (orgId) => {
  const [logs, setLogs] = useState([]);
  const [pageTrack, setPageTrack] = useState({
    currPage: undefined,
    totalPages: undefined
  });

  const logTypeOptions = [
    { value: "http", label: "API Requests" },
    { value: "screen", label: "Screen Views" },
    { value: "form", label: "Form Submissions" },
    { value: "activity", label: "Workflow Activities" }
  ];

  const fetchLogs = async (search, page, limit, filterParams = {}) => {
    try {
      const filters = {
        search,
        page,
        limit,
        ...filterParams
      };

      const response = await getMonitorLogs(orgId, filters);
      const data = response?.data;

      setLogs(data?.logs || []);
      setPageTrack({
        currPage: data?.page,
        totalPages: data?.total_pages
      });
    } catch (error) {
      toastError(error?.response?.data?.message || "Failed to fetch monitor logs");
    }
  };

  const getLogById = async (id) => {
    try {
      const response = await getLogByIdApi(orgId, id);
      return response?.data;
    } catch (error) {
      toastError(error?.response?.data?.message || "Failed to fetch log details");
      return null;
    }
  };

  return {
    logs,
    pageTrack,
    fetchLogs,
    setLogs,
    setPageTrack,
    logTypeOptions,
    getLogById
  };
};

export default useMonitorLogs;
